"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.initLogger = void 0;

var tslib_1 = require("tslib");

var browser_logs_1 = require("@datadog/browser-logs");

var loggerEnv = 'debug';

var initLogger = function initLogger(options) {
  var _a;

  browser_logs_1.datadogLogs.init(tslib_1.__assign(tslib_1.__assign({}, options), {
    site: 'datadoghq.eu',
    sampleRate: 100,
    forwardErrorsToLogs: false,
    silentMultipleInit: true
  }));
  loggerEnv = (_a = options.env) !== null && _a !== void 0 ? _a : 'debug';
};

exports.initLogger = initLogger;

var logger = function logger(name) {
  var _a;

  return loggerEnv === 'debug' ? console : (_a = browser_logs_1.datadogLogs.getLogger(name)) !== null && _a !== void 0 ? _a : browser_logs_1.datadogLogs.createLogger(name);
};

exports.logger = logger;